/**
 * @flow
 * @relayHash 86063cc61900e11ddde03d522e755848
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PdpRespLayout_viewer$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PdpRespLayoutRefetchQueryVariables = {|
  isClient: boolean,
  itemId: string,
  itemIds: $ReadOnlyArray<?string>,
  userId?: ?string,
  userIds?: ?$ReadOnlyArray<?string>,
  fetchUser: boolean,
  relationshipUserIds: $ReadOnlyArray<?string>,
  followSearchPages?: ?$ReadOnlyArray<?string>,
  fetchFollowSearch: boolean,
  isTrade: boolean,
  isMultiSku: boolean,
  fetchPdp: boolean,
  forcedCurrency?: ?Currency,
|};
export type PdpRespLayoutRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: PdpRespLayout_viewer$ref
  |}
|};
export type PdpRespLayoutRefetchQuery = {|
  variables: PdpRespLayoutRefetchQueryVariables,
  response: PdpRespLayoutRefetchQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "isClient",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUser",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "relationshipUserIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchPages",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchFollowSearch",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isMultiSku",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchPdp",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "forcedCurrency",
    "type": "Currency",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "skuId",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isPrivateOffer",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/)
  ]
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "offers",
  "storageKey": null,
  "args": null,
  "concreteType": "Offer",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canUseOfferForCheckout",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "expirationDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "totalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": (v6/*: any*/)
    },
    (v7/*: any*/)
  ]
},
v9 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "INTERNATIONAL",
    "type": "formatPhoneNumberTypes"
  }
],
v10 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId",
  "type": "String!"
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isMultiSku",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 12,
    "type": "Int"
  }
],
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ecommerceTrackingParams",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryPath",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pdpURL",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isArt",
  "args": null,
  "storageKey": null
},
v22 = [
  (v12/*: any*/),
  (v7/*: any*/)
],
v23 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1,
    "type": "Int"
  },
  {
    "kind": "Literal",
    "name": "skipImageService",
    "value": true,
    "type": "Boolean"
  }
],
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "webPath",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "versions",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "plural": true,
  "selections": [
    (v24/*: any*/)
  ]
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "placeholder",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstPhotoWebPath",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "small",
      "type": "ImageVersionTypeName!"
    }
  ],
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v28 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId",
  "type": "String"
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "shippingAddress",
  "storageKey": null,
  "args": null,
  "concreteType": "Address",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayCityStateCountry",
      "args": null,
      "storageKey": null
    },
    (v7/*: any*/)
  ]
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "largePath",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vertical",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "creationDate",
  "args": null,
  "storageKey": null
},
v38 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contemporaryTrackingString",
  "args": null,
  "storageKey": null
},
v39 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmounts",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmounts",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "USD",
      "args": null,
      "storageKey": null
    }
  ]
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "percentageOff",
  "storageKey": null,
  "args": null,
  "concreteType": "PercentageOff",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "salePrice",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "netPrice",
      "args": null,
      "storageKey": null
    }
  ]
},
v42 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "saleOriginPrice",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": (v6/*: any*/)
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "urlLabel",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "text",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "accept",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId",
  "type": "String"
},
v48 = [
  (v47/*: any*/)
],
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isCustomizable",
  "args": null,
  "storageKey": null
},
v51 = [
  {
    "kind": "Literal",
    "name": "pageType",
    "value": "PDP",
    "type": "PageType"
  }
],
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isFurniture",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedPdpUrl",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "Literal",
  "name": "page",
  "value": "searchAndBrowse",
  "type": "PageDisplayEnum"
},
v55 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v3/*: any*/)
  ]
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantityDisplay",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayPrice",
  "storageKey": null,
  "args": [
    {
      "kind": "Variable",
      "name": "isTrade",
      "variableName": "isTrade",
      "type": "Boolean"
    },
    (v54/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "plural": true,
  "selections": [
    (v55/*: any*/),
    (v56/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "percentageOff",
      "args": null,
      "storageKey": null
    },
    (v40/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceVariability",
      "args": null,
      "storageKey": null
    }
  ]
},
v58 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "classification",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemClassification",
  "plural": false,
  "selections": [
    (v37/*: any*/)
  ]
},
v59 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "creators",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCreator",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "attribution",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creator",
      "storageKey": null,
      "args": null,
      "concreteType": "Creator",
      "plural": false,
      "selections": [
        (v34/*: any*/),
        (v7/*: any*/)
      ]
    },
    (v7/*: any*/)
  ]
},
v60 = {
  "kind": "LinkedField",
  "alias": "productPhotos",
  "name": "photos",
  "storageKey": "photos(limit:1,skipImageService:true)",
  "args": (v23/*: any*/),
  "concreteType": "ItemPhoto",
  "plural": true,
  "selections": [
    (v26/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "smallPath",
      "args": null,
      "storageKey": null
    },
    (v25/*: any*/),
    (v7/*: any*/)
  ]
},
v61 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "quickViewDisplay",
  "storageKey": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    {
      "kind": "ScalarField",
      "alias": "mobileTitle",
      "name": "title",
      "args": [
        {
          "kind": "Literal",
          "name": "formatType",
          "value": "MOBILE",
          "type": "formatTitleTypes"
        }
      ],
      "storageKey": "title(formatType:\"MOBILE\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "paragraphs",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "plural": true,
      "selections": [
        (v32/*: any*/),
        (v45/*: any*/),
        {
          "kind": "ScalarField",
          "alias": "mobileText",
          "name": "text",
          "args": [
            {
              "kind": "Literal",
              "name": "formatType",
              "value": "MOBILE",
              "type": "formatTextTypes"
            }
          ],
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ]
    }
  ]
},
v62 = [
  (v12/*: any*/)
],
v63 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "masterOrZoomPath",
  "args": null,
  "storageKey": null
},
v64 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "alt",
  "args": null,
  "storageKey": null
},
v65 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v66 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v67 = [
  (v15/*: any*/),
  (v7/*: any*/)
],
v68 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "seller",
  "storageKey": null,
  "args": null,
  "concreteType": "Seller",
  "plural": false,
  "selections": (v67/*: any*/)
},
v69 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false,
  "type": "Boolean"
},
v70 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "unit",
    "args": null,
    "storageKey": null
  },
  (v44/*: any*/)
],
v71 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sortOrder",
  "args": null,
  "storageKey": null
},
v72 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "detailKey",
  "args": null,
  "storageKey": null
},
v73 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showMakeOffer",
  "args": null,
  "storageKey": null
},
v74 = [
  (v28/*: any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp",
    "type": "PageDisplayEnum"
  }
],
v75 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showHoldRequest",
  "args": null,
  "storageKey": null
},
v76 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v77 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId",
  "type": "String!"
},
v78 = [
  (v77/*: any*/)
],
v79 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "lastTransaction",
  "storageKey": null,
  "args": (v78/*: any*/),
  "concreteType": "Transaction",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v8/*: any*/),
    (v7/*: any*/)
  ]
},
v80 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showPurchase",
  "args": null,
  "storageKey": null
},
v81 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showRequestPrice",
  "args": null,
  "storageKey": null
},
v82 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showRequestSourcing",
  "args": null,
  "storageKey": null
},
v83 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showFollowCategory",
  "args": null,
  "storageKey": null
},
v84 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showAcceptOffer",
  "args": null,
  "storageKey": null
},
v85 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showPUR",
  "args": null,
  "storageKey": null
},
v86 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showSold",
  "args": null,
  "storageKey": null
},
v87 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showSale",
  "args": null,
  "storageKey": null
},
v88 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showNet",
  "args": null,
  "storageKey": null
},
v89 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showUnavailable",
  "args": null,
  "storageKey": null
},
v90 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showRetail",
  "args": null,
  "storageKey": null
},
v91 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showOriginal",
  "args": null,
  "storageKey": null
},
v92 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showOnHold",
  "args": null,
  "storageKey": null
},
v93 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showOnHoldCustom",
  "args": null,
  "storageKey": null
},
v94 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showListPriceLabel",
  "args": null,
  "storageKey": null
},
v95 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pricing",
  "storageKey": null,
  "args": null,
  "concreteType": "PriceInfoDisplay",
  "plural": false,
  "selections": [
    (v87/*: any*/),
    (v56/*: any*/),
    (v89/*: any*/),
    (v85/*: any*/),
    (v88/*: any*/),
    (v86/*: any*/),
    (v90/*: any*/),
    (v91/*: any*/),
    (v92/*: any*/),
    (v93/*: any*/),
    (v94/*: any*/)
  ]
},
v96 = [
  (v4/*: any*/),
  (v3/*: any*/),
  (v5/*: any*/)
],
v97 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v98 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "benefit",
    "args": null,
    "storageKey": null
  }
],
v99 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v100 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "daysRelativeToExpiration",
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false,
      "type": "Boolean"
    }
  ],
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v101 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "segmentCode",
  "args": null,
  "storageKey": null
},
v102 = [
  (v4/*: any*/)
],
v103 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "iconUri",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PdpRespLayoutRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PdpRespLayout_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PdpRespLayoutRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isMoreWaysToBrowseEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "MORE_WAYS_TO_BROWSE",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MORE_WAYS_TO_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "affirmEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "AFFIRM",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"AFFIRM\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "transactions",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              },
              {
                "kind": "Variable",
                "name": "itemId",
                "variableName": "itemIds",
                "type": "[String]"
              }
            ],
            "concreteType": "TransactionConnection",
            "plural": false,
            "selections": [
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isMultiSku",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TransactionEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          (v8/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isCanceled",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "onlyTradeRequestsQuote",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "useOldPdpShippingModals",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"useOldPdpShippingModals\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "PDP_SUPPORT_NUMBER_BLURB",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"PDP_SUPPORT_NUMBER_BLURB\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contactInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "ContactInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "phoneNumbers",
                "storageKey": null,
                "args": null,
                "concreteType": "support",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "support",
                    "args": (v9/*: any*/),
                    "storageKey": "support(formatType:\"INTERNATIONAL\")"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isItemInvoiceEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "INVOICE",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"INVOICE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isPdpStfEnabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "enablePdpStf",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"enablePdpStf\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isPinterestShareEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "PINTEREST_SHARE",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"PINTEREST_SHARE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFacebookShareEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FACEBOOK_SHARE",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FACEBOOK_SHARE\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": [
              (v10/*: any*/)
            ],
            "concreteType": "Item",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "affirmDisplayInfo",
                "name": "displayInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemDisplayInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "showAffirmPromo",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              (v11/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "saveSearchData",
                "storageKey": null,
                "args": null,
                "concreteType": "SaveSearchDataType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "page",
                    "args": null,
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "similarLandingItems",
                "name": "moreLikeThis",
                "storageKey": "moreLikeThis(first:12)",
                "args": (v13/*: any*/),
                "concreteType": "moreLikeThisConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "moreLikeThisEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "creators",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemCreator",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "creator",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Creator",
                                "plural": false,
                                "selections": (v22/*: any*/)
                              },
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "photos",
                            "storageKey": "photos(limit:1,skipImageService:true)",
                            "args": (v23/*: any*/),
                            "concreteType": "ItemPhoto",
                            "plural": true,
                            "selections": [
                              (v25/*: any*/),
                              (v7/*: any*/),
                              (v26/*: any*/)
                            ]
                          },
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/),
              (v15/*: any*/),
              (v27/*: any*/),
              (v18/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "defaultSkuId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "itemType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": "isNegotiable",
                "name": "canBuyerMakeOffer",
                "args": (v29/*: any*/),
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isSold",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isListingNotListed",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isListingUnlisted",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "seller",
                "storageKey": null,
                "args": null,
                "concreteType": "Seller",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isInternal",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v15/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": "monthsSinceStartDate",
                    "name": "timeSinceStartDate",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "unit",
                        "value": "MONTH",
                        "type": "TimeUnit"
                      }
                    ],
                    "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isDistinguished",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "sellerTiers",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SellerTiers",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isGoldTier",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isPlatinumTier",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sellerTierDataNotFound",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "orderFeedbackPdp",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "metadata",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "aggregatedFeedback",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AggregatedOrderFeedbackType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "overallExperience",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AggregatedOrderFeedbackQuestionType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mean",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "sellerProfile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SellerProfile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "company",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "breadcrumbs",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemBreadcrumb",
                "plural": true,
                "selections": [
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "photos",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPhoto",
                "plural": true,
                "selections": [
                  (v35/*: any*/),
                  (v7/*: any*/)
                ]
              },
              (v20/*: any*/),
              (v36/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "classification",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemClassification",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "categories",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemCategory",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "precedence",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "category",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Category",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v17/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v37/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "categorNameLevel2",
                "name": "getCategoriesByLevel",
                "storageKey": "getCategoriesByLevel(level:2)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "level",
                    "value": 2,
                    "type": "Int!"
                  }
                ],
                "concreteType": "Category",
                "plural": true,
                "selections": (v22/*: any*/)
              },
              (v21/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "creators",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemCreator",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "creator",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Creator",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v34/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "publishedItemsCount",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "urlTag",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "categorNameLevel3",
                "name": "getCategoriesByLevel",
                "storageKey": "getCategoriesByLevel(level:3)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "level",
                    "value": 3,
                    "type": "Int!"
                  }
                ],
                "concreteType": "Category",
                "plural": true,
                "selections": (v22/*: any*/)
              },
              (v38/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPricing",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "totalAmount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v39/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "prices",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Price",
                    "plural": true,
                    "selections": [
                      (v40/*: any*/),
                      (v31/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "amount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v41/*: any*/),
                  (v42/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "retailPrice",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": (v6/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "salePrice",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": (v6/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "netPrice",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "plural": false,
                    "selections": (v6/*: any*/)
                  }
                ]
              },
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isDepositAvailable",
                "args": (v29/*: any*/),
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "categoryPathItemCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pdpTypeDisplay",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "activeHold",
                "storageKey": null,
                "args": null,
                "concreteType": "Hold",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayTimeToExpire",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isNewAndMadeToOrder",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "attributes",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemAttributes",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "leadTime",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AttributeValue",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "option",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AttributeOption",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v43/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      (v44/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "customizable",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AttributeValue",
                    "plural": true,
                    "selections": [
                      (v45/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "blurbReturnPolicy",
                "name": "returnPolicy",
                "storageKey": null,
                "args": null,
                "concreteType": "ReturnPolicy",
                "plural": false,
                "selections": [
                  (v46/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notifyDays",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasShipmentQuotes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": "itemIsOnHold",
                "name": "isOnHold",
                "args": (v29/*: any*/),
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasPreQuotedShipping",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": "itemAddress",
                    "name": "displayCityStateCountry",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "fullCountryName",
                        "value": true,
                        "type": "Boolean"
                      }
                    ],
                    "storageKey": "displayCityStateCountry(fullCountryName:true)"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isGalleryRoomAddress",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "urgency",
                "storageKey": null,
                "args": (v48/*: any*/),
                "concreteType": "Urgency",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pdpBlurbDisplayInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PdpBlurbDisplayInfo",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "displayTitle",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "displaySubtitle",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              (v49/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "englishDescription",
                "args": null,
                "storageKey": null
              },
              (v50/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "creatorContent",
                "storageKey": null,
                "args": null,
                "concreteType": "BrowseContentModule",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v49/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "role",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "returnPolicy",
                "storageKey": null,
                "args": (v48/*: any*/),
                "concreteType": "ReturnPolicy",
                "plural": false,
                "selections": [
                  (v46/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "buyerCopy",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ReturnPolicyCopy",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "returnCopy",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isAvailable",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dibsReference",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "internalBuyLinks",
                "storageKey": null,
                "args": null,
                "concreteType": "InternalBuyLinkType",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "anchorText",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isDeleted",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "skus",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemSkuType",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "quantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasUnlimitedQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "quantitySelectOptions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SkuQuantityOption",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "label",
                        "args": null,
                        "storageKey": null
                      },
                      (v44/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "setSize",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": "skuLeadTime",
                    "name": "leadTime",
                    "args": (v51/*: any*/),
                    "storageKey": "leadTime(pageType:\"PDP\")"
                  }
                ]
              },
              (v19/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isComplete",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isListingListed",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "similarGridItems",
                "name": "moreLikeThis",
                "storageKey": "moreLikeThis(first:8,seller:\"EXCLUDE\")",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 8,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "seller",
                    "value": "EXCLUDE",
                    "type": "seller"
                  }
                ],
                "concreteType": "moreLikeThisConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "moreLikeThisEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v15/*: any*/),
                          (v17/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/),
                          (v14/*: any*/),
                          (v52/*: any*/),
                          (v50/*: any*/),
                          (v19/*: any*/),
                          (v53/*: any*/),
                          (v36/*: any*/),
                          (v57/*: any*/),
                          (v58/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchPdp",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewInRoomPhotos",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "viewInRoomPhotos",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "src",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "credits",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "srcSetProps",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosSrcSet",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "sizes",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "srcSet",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "centerPosition",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosCenterPosition",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "top",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "left",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "comparatorWidth",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotosComparatorWidth",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pixel",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "inches",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "microdata",
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "currency",
                        "variableName": "forcedCurrency",
                        "type": "Currency"
                      }
                    ],
                    "storageKey": null
                  },
                  (v53/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pdpMeta",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "pdpMetaItems",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v49/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "ogTitle",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "productPriceAmount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "productPriceCurrency",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "photos",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "versions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPhotoVersion",
                        "plural": true,
                        "selections": [
                          (v24/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "type",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ImageVersionType",
                            "plural": false,
                            "selections": (v62/*: any*/)
                          }
                        ]
                      },
                      (v63/*: any*/),
                      (v64/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isMissingTranslatedItemTitle",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "seller",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Seller",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "agreementStart",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "sellerPreferences",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SellerPreferences",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "trackedPhone",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Phone",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "phoneNumber",
                            "args": null,
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "orderFeedbackPdp",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "totalResults",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OrderFeedbackPdp",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "completedDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "transaction",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Transaction",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "buyer",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                              (v65/*: any*/)
                                            ]
                                          },
                                          (v7/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "shipment",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Shipment",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shippingAddress",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Address",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "displayState",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "country",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "displayCountry",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v7/*: any*/)
                                            ]
                                          },
                                          (v7/*: any*/)
                                        ]
                                      },
                                      (v7/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "overallExperience",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v66/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "rating",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "publicNote",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                      (v66/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "freetext",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "visible",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "item",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v18/*: any*/),
                                      (v38/*: any*/),
                                      (v20/*: any*/),
                                      (v68/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  },
                                  (v15/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isMakerOrManufacturer",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeAssociations",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeAssociation",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          (v34/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "liveStorefrontProfile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StorefrontProfile",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "aboutUs",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "photos",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Photo",
                            "plural": true,
                            "selections": [
                              (v33/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "type",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PhotoType",
                                "plural": false,
                                "selections": (v22/*: any*/)
                              },
                              (v7/*: any*/)
                            ]
                          },
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "fetchUser",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "favoritesByUser",
                            "storageKey": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "userIds",
                                "variableName": "userId",
                                "type": "String!"
                              }
                            ],
                            "concreteType": "Favorite",
                            "plural": true,
                            "selections": (v67/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "isClient",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "analytics",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MCAnalytics",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "metrics",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MCAnalyticsMetrics",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "responseTime",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MCMetricResponseTime",
                                    "plural": false,
                                    "selections": [
                                      (v44/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "metrics",
                    "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "metricTypes",
                        "value": [
                          "LISTING_VIEWS"
                        ],
                        "type": "[MetricType]!"
                      },
                      {
                        "kind": "Literal",
                        "name": "timeRange",
                        "value": "LAST_6_MONTHS",
                        "type": "MetricsTimeRangeEnum!"
                      }
                    ],
                    "concreteType": "MetricDetailType",
                    "plural": true,
                    "selections": [
                      (v44/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "attributes",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemAttributes",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "period",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "option",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AttributeOption",
                            "plural": false,
                            "selections": (v22/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "measurement",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemMeasurement",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "convertedMeasurements",
                        "storageKey": "convertedMeasurements(unit:\"IN\")",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "IN",
                            "type": "unitType"
                          }
                        ],
                        "concreteType": "ItemConvertedMeasurementsType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "width",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "height",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "hoverDimensionsWidth",
                        "name": "display",
                        "storageKey": "display(addLabel:false,fields:[\"width\"])",
                        "args": [
                          (v69/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "width"
                            ],
                            "type": "[measurementFieldType]"
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "plural": true,
                        "selections": (v70/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "hoverDimensionsHeight",
                        "name": "display",
                        "storageKey": "display(addLabel:false,fields:[\"height\"])",
                        "args": [
                          (v69/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "fields",
                            "value": [
                              "height"
                            ],
                            "type": "[measurementFieldType]"
                          }
                        ],
                        "concreteType": "ItemDisplayMeasurementType",
                        "plural": true,
                        "selections": (v70/*: any*/)
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "sortedPhotos",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v35/*: any*/),
                      (v63/*: any*/),
                      (v64/*: any*/),
                      (v71/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "imageSkuXrefs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ImageSkuXref",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pdpDetailsDisplay",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PdpDetail",
                    "plural": true,
                    "selections": [
                      (v72/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "delimiter",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "detailDisplayName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "detailValues",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v66/*: any*/),
                          (v72/*: any*/),
                          (v17/*: any*/),
                          (v34/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "linkOrder",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "type": "PdpDetailVersionsValue",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "price",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": (v6/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "dealerDetailsDisplayInfo",
                    "name": "displayInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemDisplayInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "ctas",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CTADisplay",
                        "plural": false,
                        "selections": [
                          (v73/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "sellerItems",
                    "name": "moreLikeThis",
                    "storageKey": "moreLikeThis(first:4,seller:\"INCLUDE\")",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 4,
                        "type": "Int"
                      },
                      {
                        "kind": "Literal",
                        "name": "seller",
                        "value": "INCLUDE",
                        "type": "seller"
                      }
                    ],
                    "concreteType": "moreLikeThisConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "moreLikeThisEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v14/*: any*/),
                              (v52/*: any*/),
                              (v50/*: any*/),
                              (v19/*: any*/),
                              (v53/*: any*/),
                              (v36/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v59/*: any*/),
                              (v60/*: any*/),
                              (v61/*: any*/),
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchUser",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": (v74/*: any*/),
                        "concreteType": "ItemDisplayInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "ctas",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "plural": false,
                            "selections": [
                              (v75/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "complementaryItems",
                    "storageKey": "complementaryItems(first:12)",
                    "args": (v13/*: any*/),
                    "concreteType": "complementaryItemsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "complementaryItemsEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v61/*: any*/),
                              (v52/*: any*/),
                              (v50/*: any*/),
                              (v15/*: any*/),
                              (v53/*: any*/),
                              (v36/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v59/*: any*/),
                              (v60/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "Condition",
                                "passingValue": true,
                                "condition": "isClient",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "ecommerceTrackingParams",
                                    "args": (v48/*: any*/),
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "displayPrice",
                    "storageKey": null,
                    "args": [
                      (v28/*: any*/),
                      (v54/*: any*/)
                    ],
                    "concreteType": "ItemDisplayPriceType",
                    "plural": true,
                    "selections": [
                      (v55/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canBuyerMakeOffer",
                    "args": (v29/*: any*/),
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchUser",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isInProcurement",
                    "args": (v76/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasActiveHoldForBuyer",
                    "args": (v78/*: any*/),
                    "storageKey": null
                  },
                  (v79/*: any*/)
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isClient",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "pdpTrackingVpvParams",
                    "args": (v48/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "makeOfferVpvParams",
                    "name": "pdpTrackingVpvParams",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "excludedPurchaseStatuses",
                        "value": [
                          "RET",
                          "CUST"
                        ],
                        "type": "[PurchaseStatuses]"
                      },
                      (v47/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasRequestedHoldForBuyer",
                    "args": (v78/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "displayInfo",
                    "storageKey": null,
                    "args": (v74/*: any*/),
                    "concreteType": "ItemDisplayInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "ctas",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CTADisplay",
                        "plural": false,
                        "selections": [
                          (v75/*: any*/),
                          (v80/*: any*/),
                          (v73/*: any*/),
                          (v81/*: any*/),
                          (v82/*: any*/),
                          (v83/*: any*/),
                          (v84/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pricing",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PriceInfoDisplay",
                        "plural": false,
                        "selections": [
                          (v85/*: any*/),
                          (v86/*: any*/),
                          (v87/*: any*/),
                          (v88/*: any*/),
                          (v56/*: any*/),
                          (v89/*: any*/),
                          (v90/*: any*/),
                          (v91/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isMultiSku",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "skus",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": (v74/*: any*/),
                        "concreteType": "SkuDisplayInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "ctas",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "plural": false,
                            "selections": [
                              (v80/*: any*/),
                              (v73/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v83/*: any*/),
                              (v84/*: any*/)
                            ]
                          },
                          (v95/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstPhotoWebPath",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "thumb",
                            "type": "ImageVersionTypeName!"
                          }
                        ],
                        "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pricing",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemPricing",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hidePrice",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "retailPrice",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "plural": false,
                            "selections": (v96/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "netPrice",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "plural": false,
                            "selections": (v96/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "salePrice",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "plural": false,
                            "selections": (v96/*: any*/)
                          },
                          (v41/*: any*/),
                          (v42/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "leadTime",
                        "args": (v51/*: any*/),
                        "storageKey": "leadTime(pageType:\"PDP\")"
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variableAttributeSelections",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "variableAttributeSelectionsType",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "variableAttribute",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "VariableAttribute",
                            "plural": false,
                            "selections": (v67/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "swatch",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Swatch",
                            "plural": false,
                            "selections": (v67/*: any*/)
                          },
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v79/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": "itemDisplayInfo",
                    "name": "displayInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemDisplayInfo",
                    "plural": false,
                    "selections": [
                      (v95/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "variableAttributes",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VariableAttribute",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variableAttributeData",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VariableAttributeSortType",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "primaryAttribute",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Attribute",
                            "plural": false,
                            "selections": (v22/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "swatchSort",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SwatchSort",
                            "plural": true,
                            "selections": [
                              (v71/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "swatch",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Swatch",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v34/*: any*/),
                                  (v49/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "imageUrl",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "material",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SwatchAttributeByName",
                                    "plural": false,
                                    "selections": (v62/*: any*/)
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "color",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SwatchAttributeByName",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "parentName",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isEnabledDesignerConnection",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "postContactSellerDesignerConnection",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"postContactSellerDesignerConnection\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSeoQuicklookEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEO_QUICKLOOK",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isCompleteTheLookDisabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableCompleteTheLook",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"disableCompleteTheLook\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isPdpUrlTranslationEnabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "translatedPdpUrls",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "regionalInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "RegionalInfo",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "countryCode",
                "args": null,
                "storageKey": null
              },
              (v7/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isMessageCenterEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "MESSAGE_CENTER",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isReviewsEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "ORDER_FEEDBACK",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isEmbeddedMakeOfferTestDisabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disablePdpEmbeddedMakeOfferTest",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"disablePdpEmbeddedMakeOfferTest\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isNewSellerPillEnabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "enableNewSellerPill",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"enableNewSellerPill\")"
          },
          {
            "kind": "ScalarField",
            "alias": "disableEmailOnlyMc",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DISABLE_EMAIL_ONLY_MC",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_EMAIL_ONLY_MC\")"
          },
          {
            "kind": "ScalarField",
            "alias": "disableEmailOnlyRegistration",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DISABLE_EMAIL_ONLY_REGISTRATION",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_EMAIL_ONLY_REGISTRATION\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "gdprDisplayInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "gdprDisplayInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isGdprApplicable",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "marketingOptInMessage",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isContactSupportEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "CONTACT_1STDIBS",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"CONTACT_1STDIBS\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isAboutTheMakerEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "ABOUT_THE_MAKER",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"ABOUT_THE_MAKER\")"
          },
          {
            "kind": "ScalarField",
            "alias": "disableMakeOfferContactTest",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableMakeOfferContactTest",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"disableMakeOfferContactTest\")"
          },
          (v7/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "buyerItemConversation",
                "storageKey": null,
                "args": [
                  (v77/*: any*/),
                  (v10/*: any*/)
                ],
                "concreteType": "Conversation",
                "plural": false,
                "selections": (v67/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v76/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": "canSeeNetPrice",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_NET_PRICE",
                        "type": "String!"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_NET_PRICE\")"
                  },
                  (v15/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVerifiedTrade",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v97/*: any*/),
                      (v34/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "measurementUnit",
                        "args": null,
                        "storageKey": null
                      },
                      (v65/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "recentHistoryList",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RecentHistoryItem",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eventDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v27/*: any*/),
                          (v20/*: any*/),
                          (v18/*: any*/),
                          (v17/*: any*/),
                          (v16/*: any*/),
                          (v15/*: any*/),
                          (v19/*: any*/),
                          (v68/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVip",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canRequestShippingQuotePermission",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_REQUEST_SHIPPING_QUOTE",
                        "type": "String!"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_REQUEST_SHIPPING_QUOTE\")"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authMetadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserExistsMetadataType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "emailOnly",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canShowSellerName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canCheckoutWithCheck",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_CHECKOUT_CHECK",
                        "type": "String!"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"B_CHECKOUT_CHECK\")"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tradeFirm",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "rewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "educationMessagingSegments",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RewardsMessagingSegment",
                            "plural": true,
                            "selections": (v98/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pointsToMaintainStatus",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pointsMessagingSegments",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RewardsMessagingSegment",
                            "plural": true,
                            "selections": (v98/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "homepageMessagingSegments",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RewardsMessagingSegment",
                            "plural": true,
                            "selections": (v98/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "postCheckoutMessagingSegments",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RewardsMessagingSegment",
                            "plural": true,
                            "selections": (v98/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tpnRole",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmTPNRole",
                        "plural": false,
                        "selections": [
                          (v99/*: any*/)
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activePromotion",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "itemId",
                        "variableName": "itemId",
                        "type": "String"
                      }
                    ],
                    "concreteType": "Promotion",
                    "plural": false,
                    "selections": [
                      (v99/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  (v7/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchFollowSearch",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "favorites",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1,
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "pages",
                            "variableName": "followSearchPages",
                            "type": "[String]"
                          },
                          {
                            "kind": "Literal",
                            "name": "types",
                            "value": [
                              "SEARCH"
                            ],
                            "type": "[types]"
                          }
                        ],
                        "concreteType": "favoritesConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "favoritesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Favorite",
                                "plural": false,
                                "selections": (v67/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirmDesignManagerProfile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmDesignManagerProfileType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasAccount",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "socialNetworks",
                        "storageKey": "socialNetworks(socialNetworkNames:\"DESIGN_MANAGER\")",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "socialNetworkNames",
                            "value": "DESIGN_MANAGER",
                            "type": "[SocialNetworkNames]"
                          }
                        ],
                        "concreteType": null,
                        "plural": true,
                        "selections": [
                          (v66/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "type": "DesignManagerSocialNetworkType",
                            "selections": [
                              (v31/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "expiringPromotion",
                        "storageKey": "expiringPromotion(daysToExpiration:14,promoCodes:[\"TRADEWELCOME\",\"TRADESHIP\",\"RISKFREE\"])",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 14,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADESHIP",
                              "RISKFREE"
                            ],
                            "type": "[String]"
                          }
                        ],
                        "concreteType": "Promotion",
                        "plural": false,
                        "selections": [
                          (v100/*: any*/),
                          (v99/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirm",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rewards",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "currentPromoSegment",
                                "storageKey": null,
                                "args": (v48/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "plural": false,
                                "selections": [
                                  (v101/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isTrade",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "loyalty",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmLoyaltyType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "currentYearSpend",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "plural": false,
                                    "selections": (v102/*: any*/)
                                  },
                                  (v31/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "rewards",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmRewards",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "currentProgram",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "programInfo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "plural": false,
                                        "selections": [
                                          (v99/*: any*/),
                                          (v34/*: any*/),
                                          (v103/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "nextProgram",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "programInfo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          (v103/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirmRewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentPromoSegment",
                            "storageKey": null,
                            "args": (v48/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "plural": false,
                            "selections": [
                              (v101/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "promotion",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "plural": false,
                                "selections": [
                                  (v99/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "buyerExpirationDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "expiringPromoSegment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "expiringSegmentCode",
                                "args": null,
                                "storageKey": null
                              },
                              (v100/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "vipUserRelationships",
                "name": "userRelationships",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "relationshipType",
                    "value": "VIP",
                    "type": "relationshipType!"
                  },
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "relationshipUserIds",
                    "type": "[String]!"
                  }
                ],
                "concreteType": "UserRelationship",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userDataB",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v66/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "VipRepData",
                        "selections": [
                          (v97/*: any*/),
                          (v65/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "phoneNumber",
                            "args": (v9/*: any*/),
                            "storageKey": "phoneNumber(formatType:\"INTERNATIONAL\")"
                          }
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isClient",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "relevantShippingInfo",
                "storageKey": null,
                "args": [
                  (v28/*: any*/),
                  (v10/*: any*/)
                ],
                "concreteType": "QueryRelevantShippingInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipmentQuote",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "buyerSubTotalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v6/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isCustom",
                        "args": null,
                        "storageKey": null
                      },
                      (v31/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "complimentaryShipping",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "subTotalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v102/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isNew",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "serviceMethod",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isWhiteGlove",
                            "args": null,
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceMethodType",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "region",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Region",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "apiType",
                                "args": null,
                                "storageKey": null
                              },
                              (v99/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "regionName",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "regionType",
                                "args": null,
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "handlingTimeDisplay",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "buyerServiceMethodDisplay",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipment",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shipment",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeProgramsQuery",
                "storageKey": "tradeProgramsQuery(programCodes:[\"BRONZE\"])",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "programCodes",
                    "value": [
                      "BRONZE"
                    ],
                    "type": "[String]"
                  }
                ],
                "concreteType": "LoyaltyProgram",
                "plural": true,
                "selections": [
                  (v103/*: any*/),
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "parentPrograms",
                    "name": "tradeProgramsQuery",
                    "storageKey": "tradeProgramsQuery(programCodes:[\"MEMBER\",\"BRONZE\",\"SILVER\",\"GOLD\",\"PLATINUM\"])",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "programCodes",
                        "value": [
                          "MEMBER",
                          "BRONZE",
                          "SILVER",
                          "GOLD",
                          "PLATINUM"
                        ],
                        "type": "[String]"
                      }
                    ],
                    "concreteType": "LoyaltyProgram",
                    "plural": true,
                    "selections": [
                      (v99/*: any*/),
                      (v34/*: any*/),
                      (v103/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "maxPoints",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "minPoints",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchPdp",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": "isRequestMoreImagesEnabled",
                "name": "isEnabledByLocale",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "REQUEST_MORE_IMAGES",
                    "type": "String!"
                  }
                ],
                "storageKey": "isEnabledByLocale(featureName:\"REQUEST_MORE_IMAGES\")"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PdpRespLayoutRefetchQuery",
    "id": "app-buyer-finding/213.0.0-2019-04-23T14:40:24.662Z/PdpRespLayoutRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '00342894b3c1a5b1d48c7573cd15d552';
module.exports = node;
